<template>
    <ion-menu :disabled="disabled" ref="menu" content-id="main-content" side="end" type="overlay"
        @ionDidOpen="openIonicMenu()">
        <ion-header class="ion-no-border">
            <ion-toolbar style="background-color: var(--ion-color-white);" color="white">
                <ion-buttons slot="start">
                    <ion-button @click="closeMenu()" color="primary">
                        <mdicon name="chevron-right" slot="icon-only" />
                    </ion-button>
                </ion-buttons>
                <ion-title color="primary">
                    <span class="ion-text-uppercase">Notificaties</span>
                </ion-title>

                <ion-buttons slot="end">
                    <ion-button :disabled="all_notifications.length == 0" @click="deleteConfirm()" color="primary">
                        <mdicon :name="all_notifications.length == 0 ? 'delete-empty' : 'trash-can-outline'"
                            slot="icon-only" />
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <notifications></notifications>
        </ion-content>
    </ion-menu>
</template>

<script>
import Notifications from '@/components/Notifications.vue'
import { IonMenu, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonContent, alertController } from '@ionic/vue'
import { db } from '@/services/db'

export default {
    name: 'novacheck-sidemenu',
    components: {
        Notifications,
        IonMenu,
        IonHeader,
        IonToolbar,
        IonButtons,
        IonButton,
        IonTitle,
        IonContent
    },
    data() {
        return {
            all_notifications: [],
            disabled: false
        }
    },
    methods: {
        deleteAllNotifications() {
            this.all_notifications.forEach((notification) => {
                db.notifications.delete(notification.id)
                this.$requests.delete('notifications', '/notifications/' + notification.id, notification.id)
            })

            this.all_notifications = []
        },
        deleteConfirm() {
            alertController.create({
                header: 'Verwijderen',
                message: 'Weet je zeker dat je deze notificatie wilt verwijderen?',
                buttons: [
                    {
                        text: 'Annuleren',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Cancel clicked');
                        }
                    }, {
                        text: 'Verwijderen',
                        handler: () => {
                            this.deleteAllNotifications()
                        }
                    }
                ]
            }).then(alert => {
                alert.present();
            });
        },
        closeMenu() {
            this.$store.commit('setShowSidebar', false)
            this.closeIonicMenu();
        },
        closeIonicMenu() {
            // Verifieer of de ref bestaat en roep de 'close' methode aan
            if (this.$refs.menu) {
                this.$refs.menu.$el.close();
                this.$store.commit('setShowSidebar', false)
            }
        },
        async openIonicMenu() {
            // Verifieer of de ref bestaat en roep de 'open' methode aan
            if (this.$refs.menu) {
                this.$refs.menu.$el.open();
                this.$store.commit('setShowSidebar', true)
            }

            this.$requests.get('notifications', '/notifications')
            this.all_notifications = await db.notifications.toArray()
        },
    },
    watch: {
        "$route.name": {
            handler(val) {
                if (val === 'inspections-list') {
                    this.disabled = false
                } else {
                    this.disabled = true
                }
            },
            immediate: true
        },
        "$store.getters.getShowSidebar": {
            handler(value) {
                if (value) {
                    this.openIonicMenu()
                } else {
                    this.closeIonicMenu()
                }
            },
        }
    },
}

</script>
